import React from "react"
import {Button, Result} from "antd"
import {translateUi} from "../../i18n/translateUi"

interface AppErrorBoundaryState {
    hasError: boolean
}

interface AppErrorBoundaryProps {
    children: React.ReactNode
}

class AppErrorBoundary extends React.Component<AppErrorBoundaryProps, AppErrorBoundaryState> {
    state: AppErrorBoundaryState = {
        hasError: false
    }

    static getDerivedStateFromError(): AppErrorBoundaryState {
        return {hasError: true}
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
        if (process.env.NODE_ENV === "development") {
            console.error(translateUi("Необработанная ошибка интерфейса"), error, errorInfo)
        }
    }

    private reloadPage = () => {
        window.location.reload()
    }

    render() {
        if (!this.state.hasError) {
            return this.props.children
        }

        return (
            <Result
                status="error"
                title={translateUi("Не удалось открыть страницу")}
                subTitle={translateUi("Произошла непредвиденная ошибка. Перезагрузите страницу и повторите действие.")}
                extra={(
                    <Button type="primary" onClick={this.reloadPage}>
                        {translateUi("Перезагрузить страницу")}
                    </Button>
                )}
            />
        )
    }
}

export default AppErrorBoundary
